// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h2.NwiKroJtuI3Nke {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
h2.NwiKroJtuI3Nke > span {
  display: inline-flex;
  margin-left: 8px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"collaboratorsHeading": `NwiKroJtuI3Nke`
};
export default ___CSS_LOADER_EXPORT___;
